import { combineReducers } from 'redux';
import authReducer from './auth/reducers';
import bioReducer from './bio/reducers';
import cuadrosReducer from './cuadros/reducers';
import faqsReducer from './faqs/reducers';
import seriesReducer from './series/reducers';
import userReducer from './user/reducers';

export default combineReducers({
  auth: authReducer,
  bio: bioReducer,
  cuadros: cuadrosReducer,
  faqs: faqsReducer,
  series: seriesReducer,
  user: userReducer,
});
